import React from 'react';
import { useAssistantOptional } from './AssistantContext';
import { openAssistant } from './assistantApi';
import { TROUBLESHOOT_STARTER } from './assistantLayout';

export default function TroubleshootThis({ pins, label = 'Troubleshoot' }) {
  const assistant = useAssistantOptional();
  if (assistant && (assistant.status?.enabled !== true || assistant.status?.canTroubleshoot !== true)) {
    return null;
  }

  return (
    <button
      type="button"
      className="text-sm font-medium text-blue-700 hover:text-blue-900 underline-offset-2 hover:underline"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        openAssistant({ mode: 'troubleshoot', pins, seedMessage: TROUBLESHOOT_STARTER });
      }}
    >
      {label}
    </button>
  );
}
